<template>
  <div class="navbar-fixed">
    <nav class="z-depth-2 blue-grey darken-4 white-text nav-extended">
      <div class="nav-wrapper">
        <div class="col s12">
          <a href="#" class="white-text" id="header_logo">
            Optweex
            <b>Experience</b>
          </a>

          <ul id="nav-mobile" class="right">
            <li>
              <a
                id="dropdown-trigger-user"
                class="dropdown-trigger circle white-text"
                href="#!"
                data-target="dropdown_user"
              >
                <img v-bind:src="imgUser" alt class="circle" width="40px" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="nav-content">
        <Tabs
          v-bind:tabNovaSimulacao="tabNovaSimulacao"
          v-bind:tabInicio="tabInicio"
          v-bind:tabMinhasSimulacoes="tabMinhasSimulacoes"
          @DefineTab="atualizarTab"
        />
      </div>

    
    </nav>
  </div>
</template>
<script>
import Tabs from "@/components/Tabs.vue";
import firebase from "firebase";
import $ from "jquery";
export default {
  name: "Navbar",
  components: {
    Tabs
  },
  data() {
    let tab = this.$route.params.tab;
    return {
      tabNovaSimulacao: tab == "nova-simulacao" ? "active" : "",
      tabInicio: tab == "inicio" || tab == "" ? "active" : "",
      tabMinhasSimulacoes: tab == "minhas-simulacoes" ? "active" : "",
      imgUser: firebase.auth().currentUser.photoURL
    };
  },
  methods: {
    atualizarTab: function(data) {
      console.log(data);
    }
  },
  mounted() {
    firebase.auth().currentUser.photoURL;
    $("#tabs-navbar").addClass("tabs-transparent");
  }
};
</script>